import { render, staticRenderFns } from "./option_select.vue?vue&type=template&id=1a995630&"
import script from "./option_select.vue?vue&type=script&lang=js&"
export * from "./option_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports